import React from 'react';
import {
	RARITIES,
	ATTRIBUTES,
	PART_TYPES,
	STATS,
	SKILL_INFO,
} from './constants';

const AddUnit = (( { series, skills, wordtags, addParts, addPartStatus, getSkills, refreshSkillsStatus } ) => {

	let statusMessageInterval = null;

	const showStatusMessage = (message, type) => {

		clearInterval(statusMessageInterval);
		document.querySelector('.status-box-' + type).textContent = message;
		statusMessageInterval = window.setTimeout(() => {

			showStatusMessage('', type);
		}, 3000);		
	};

	const resetSelectedFieldValues = () => {

		document.querySelector('select[name=field_damage_type]').selectedIndex = 0;
	};

	const checkIfHasEmpty = (arrayOfObjects) => {

		let hasAnEmptyObject = false;
		arrayOfObjects.forEach((obj) => {

			if ( !obj.trim() ) {

				hasAnEmptyObject = true;
			}
		});

		return hasAnEmptyObject;
	};

	const checkIfHasNonNumerical = (arrayOfObjects) => {

		let hasNonNumericalObject = false;
		arrayOfObjects.forEach((obj) => {

			if ( isNaN(obj) ) {

				hasNonNumericalObject = true;

			}
		});

		return hasNonNumericalObject;
	}

	const submitParts = () => {

		let hasErrors = false;
		const partBasics = document.querySelector('.fields-add-parts');

		const rarity = partBasics.querySelector('select[name=field_rarity]').value;
		const attribute = partBasics.querySelector('select[name=field_attribute]').value;
		const series = partBasics.querySelector('select[name=field_series]').value;
		const name = partBasics.querySelector('input[name=field_name]').value;
		const subname = partBasics.querySelector('input[name=field_subname]').value;

		const parts = document.querySelectorAll('.part-specifics');
		const partsToAdd = [];

		if ( checkIfHasEmpty([name]) ) {

			showStatusMessage('You must provide a valid Name / Subname.','parts');
			hasErrors = true;
		} else {

			Array.from(parts).forEach((part) => {

				const type = part.querySelector('select[name=field_part_type]').value;
				const integration = part.querySelector('input[name=field_integration]').value;
				const damageType = part.querySelector('select[name=field_damage_type]').value;

				const armor = part.querySelector('input[name=field_armor]').value;
				const shotAtk = part.querySelector('input[name=field_atk_shot]').value;
				const meleeAtk = part.querySelector('input[name=field_atk_melee]').value;
				const shotDef = part.querySelector('input[name=field_def_shot]').value;
				const meleeDef = part.querySelector('input[name=field_def_melee]').value;
				const beamRes = part.querySelector('input[name=field_res_beam]').value;
				const physRes = part.querySelector('input[name=field_res_phys]').value;

				const wordtag1 = part.querySelector('select[name=field_wordtag_1]').value;
				const wordtag2 = part.querySelector('select[name=field_wordtag_2]').value;

				const statsArray = [armor, shotAtk, meleeAtk, shotDef, meleeDef, beamRes, physRes];
				if ( checkIfHasEmpty(statsArray) || checkIfHasNonNumerical(statsArray) ) {

					showStatusMessage('All unit statistics must be provided and has valid values. (e.g. armor, shot_atk, etc.)', 'parts');
					hasErrors = true;
				}

				const trait = part.querySelector('textarea[name=field_trait]').value;
				const hasASkill = part.querySelector('input[name=field_hasSkill]').checked;

				const skillId = part.querySelector('select[name=skill_id]').value;

				partsToAdd.push({
					'name': name.trim(),
					'subname': subname.trim(),
					'rarity': rarity,
					'series_id': series,
					'attribute_id': attribute,				
					'part_id': type,
					'integration': integration,
					'damage_type': damageType,
					'armor': armor.trim(),
					'atk_shot': shotAtk.trim(),
					'atk_melee': meleeAtk.trim(),
					'def_shot': shotDef.trim(),
					'def_melee': meleeDef.trim(),
					'res_beam': beamRes.trim(),
					'res_phys': physRes.trim(),
					'wordtag1_id': wordtag1,
					'wordtag2_id': wordtag2,
					'trait': hasASkill ? null : trait.trim(),
					'skill_id': hasASkill ? skillId : 0,
				});
			});
		}
	
		if ( !hasErrors ) {

			addParts(partsToAdd);
		}
	};

	const toggleSkillTraitField = (event) => {

		const container = event.target.parentNode.parentNode;
		const skillField = container.querySelector('.skill-field');
		const traitField = container.querySelector('.trait-field');

		skillField.style.display = 'none';
		traitField.style.display = 'none';

		if ( event.target.checked ) {

			skillField.style.display = 'block';
		} else {

			traitField.style.display = 'block';
		}
	};

	const populateSkillInfoFields = (event) => {

		const container = event.target.parentNode.parentNode;
		const skillInfoContainer = container.querySelector('.skill-info');

		const skillId = event.target.value;
		const skill = skills.filter(skill => {

			return parseInt(skill.skill_id) === parseInt(skillId);
		});

		const fields = [
			'skill_type',
			'skill_pierce',
			'skill_power',
			'skill_magazine',
			'skill_recovery',
			'skill_effect_time',
			'skill_cooldown',
			'skill_description'
		];

		fields.forEach(field => {

			const targetField = skillInfoContainer.querySelector(`input[name=${field}]`) ||
			skillInfoContainer.querySelector(`textarea[name=${field}]`);

			if ( skill[0][field] == null ) {
				
				targetField.parentNode.style.display = 'none';
				targetField.value = '';
			} else {

				targetField.value = skill[0][field];
				targetField.parentNode.style.display = targetField.nodeName === 'TEXTAREA' ? 'block' : 'inline-block';				
			}
		});
	};

	return (
		<div className='ph2 fields-add-parts'>
			<h2>Add New Parts</h2>
			<div className='status-box-parts h2 bg-red white flex items-center ph3 b'>&nbsp;</div>
			<div className='pv2 f7 green'>{addPartStatus}</div>
			<div className='add-part-single ba b--gray pa2 mt2'>
				<label className='pa1 dib f7'>
					<span className='mt2 mb1 db b'>Rank</span>
					<select className='f5' name='field_rarity'>
						{
							RARITIES.map((item) => {

								return <option key={'rarity-' + item} value={item}>{item}</option>;
							})
						}
					</select>
				</label>
				<label className='pa1 f7 dib'>
					<span className='mt2 mb1 db b'>Attribute</span>
					<select className='f5' name='field_attribute'>
						{
							Object.entries(ATTRIBUTES).map((item) => {

								return <option key={'attribute-' + item[0]} value={item[0]}>{item[1]}</option>
							})
						}
					</select>
				</label>
				<label className='pa1 dib f7'>
					<span className='mt2 mb1 db b'>Series</span>
					<select className='f5' name='field_series'>
					{
						series.length> 0 ?
							series.map(item => {

								return (
									<option key={item.series_id} value={item.series_id}>{item.series_name}</option>
								);
							})
						:
							<option value='0'>Fetching Series...</option>
					}
					</select>
				</label>
				<div className='db dib-ns pv2'>
					<label className='ph1 f7 dib'>
						<span className='mt2 mb1 db b'>Name</span>
						<input type='text' name='field_name' className='f5' />
					</label>
					<label className='ph1 f7 dib'>
						<span className='mt2 mb1 db b'>Sub Name</span>
						<input type='text' name='field_subname' className='f5' />
					</label>
				</div>
				<fieldset className='bg-white shadow-1 bn part-specifics pv2 mt3 flex-ns flex-wrap-ns justify-between-ns'>
					<legend className='ph2 bg-white dark-blue'>Part Information</legend>
					<fieldset className='b--near-white ma0 w-50-ns'>
						<legend className='dark-blue'>Basic Info</legend>
						<label className='ph1 dib f7'>
							<span className='mt2 mb1 db b'>Type:</span>
							<select className='f5' name='field_part_type' onChange={resetSelectedFieldValues}>
								{
									Object.entries(PART_TYPES).map((item) => {

										if ( item[0] === 'Pilot' ) {

											return Object.entries(item[1]).map((pilot) => {

												return <option key={'attribute-' + pilot[0]} value={pilot[0]}>Pilot - {pilot[1]}</option>
											});

										} else if ( item[0] === 'Melee' ) {

											return Object.entries(item[1]).map((melee) => {

												return <option key={'attribute-' + melee[0]} value={melee[0]}>Melee Weapon - {melee[1]}</option>
											});

										} else if ( item[0] === 'Ranged' ) {

											return Object.entries(item[1]).map((ranged) => {

												return <option key={'attribute-' + ranged[0]} value={ranged[0]}>Ranged Weapon - {ranged[1]}</option>
											});

										} else {

											return <option key={'attribute-' + item[0]} value={item[0]}>{item[1]}</option>
										}
									})
								}
							</select>
						</label>
						<label className='ph1 dib f7 pa2'>
							<span className='mt2 mb1 db b'>Integration:</span>
							<input type='text' name='field_integration' className='w-90' />
						</label>
						<label className='ph1 dib f7 pa2'>
							<span className='mt2 mb1 db b'>Damage Type:</span>
							<select className='f5' name='field_damage_type'>
								<option value=''>N/A</option>
								<option value='Physical'>Physical</option>
								<option value='Beam'>Beam</option>
							</select>
						</label>
					</fieldset>
					<fieldset className='b--near-white ma0 f5 w-50-ns flex flex-wrap-ns'>
						<legend className='ph2 dark-blue'>Statistics</legend>
						{
							Object.entries(STATS).map(item => {

								return (
									<label key={item[0]} className='dib pa2 f7' style={{flexGrow: 1}}>
										<span className='db pv1 b'>{item[1]}</span>
										<input name={'field_' + item[0]} />
									</label>
								);
							})
						}
					</fieldset>
					<div className='flex flex-wrap w-100'>
						<fieldset className='b--near-white ma0 w-100 w-50-ns'>
							<legend className='ph2 dark-blue'>Wordtags</legend>
							<label className='pa1 dib f7'>
								<span className='mt2 mb1 db b'>Wordtag 1</span>
								<select className='f5' name='field_wordtag_1'>
								{
									series.length> 0 ?
										wordtags.map(item => {

											return (
												<option key={item.wordtag_id} value={item.wordtag_id}>{item.wordtag_name}</option>
											);
										})
									:
										<option value='0'>Fetching Series...</option>
								}
								</select>
							</label>
							<label className='pa1 dib f7'>
								<span className='mt2 mb1 db b'>Wordtag 2</span>
								<select className='f5' name='field_wordtag_2'>
								{
									series.length> 0 ?
										wordtags.map(item => {

											return (
												<option key={item.wordtag_id} value={item.wordtag_id}>{item.wordtag_name}</option>
											);
										})
									:
										<option value='0'>Fetching Series...</option>
								}
								</select>
							</label>
						</fieldset>
						<fieldset className='b--near-white mt2 ma0-ns pa2 f5 w-100 w-50-ns'>
							<legend className='ph2 dark-blue'>Skill / Trait</legend>
							<label className='dib f6 mv2 pointer'><input type='checkbox' name='field_hasSkill' onClick={toggleSkillTraitField} /> Has a skill?</label>
							<label className='db pv1 trait-field'>
								<span className='f7 b'>Trait</span>
								<textarea name='field_trait' className='w-100 h3'></textarea>
							</label>
							<fieldset className='dn mv2 skill-field f7'>
								<legend className='ph2 dark-blue'>Skill Information</legend>
								<div>
									<button onClick={getSkills}>Refresh List</button>
									<span className='dib ml2'>{refreshSkillsStatus}</span>
								</div>
								<label className='pa1 dib mt2 b'>Select a skill:
									<select className='ml2 f5 mr1' name='skill_id' onChange={populateSkillInfoFields}>
										<option value=''>Select a skill</option>
									{

										skills.length> 0 ?
											skills.map(item => {

												return (
													<option key={item.skill_id} value={item.skill_id}>{item.skill_name}</option>
												);
											})
										:
											<option value='0'>Fetching Skills...</option>
									}
									</select>
								</label>
								<div className='skill-info'>
									{
										Object.entries(SKILL_INFO).map((item) => {

											return (
												<label key={'skill-info-' + item} className='ph1 dn f7'>
													<span className='mt2 mb1 db b'>{item[0]}</span>
													<input name={item[1]} readOnly />
												</label>
											);
										})
									}
									<label className='ph1 dn f7'>
										<span className='mt2 mb1 db b'>Description</span>
										<textarea name='skill_description' readOnly className='h3 pa1 w-100'></textarea>
									</label>
								</div>
							</fieldset>
						</fieldset>
					</div>
				</fieldset>
			</div>
			<div className='tr pa2'>
				<button className='pa2 mr0 pointer grow bg-brand-magenta white bn pv2 ph3' onClick={submitParts}>Add Unit(s)</button>
			</div>
		</div>
	);
});

export default AddUnit;